import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=2f7fc9e5"
import script from "./Pass.vue?vue&type=script&lang=js"
export * from "./Pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports